// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Banner_wrapper__dEj_4","inner":"Banner_inner__nWG1N","content":"Banner_content__05Rnu","full":"Banner_full___M89n","copy":"Banner_copy__mYKeO"};